import { combineReducers } from 'redux'
import ActionPlanReducer from './ActionPlanReducer'
import FormRestrictionsReducer from './FormRestrictionsReducer'
import AvaliableOrganizationsReducer from './AvaliableOrganizationsReducer'
import ConfigurationReducer from './ConfigurationReducer'
import formEditorReducer from './FormEditorReducer'
import i18nReducer from './i18nReducer'
import LayoutReducer from './LayoutReducer'
import LoginReducer from './LoginReducer'
import multiuserReducer from './MultiuserReducer'
import OrganizationReducer from './OrganizationReducer'
import PortalTranslationDataReducer from './PortalTranslationDataReducer'
import PortalTranslationReducer from './PortalTranslationReducer'
import TestingOptionsReducer from './TestingOptionsReducer'
import tutorialsReducer from './TutorialsReducer'
import userReducer from './UserReducer'
import FormsReducer from './FormsReducer'

const RootReducer = combineReducers({
  organization: OrganizationReducer,
  login: LoginReducer,
  actionPlan: ActionPlanReducer,
  user: userReducer,
  layout: LayoutReducer,
  tutorials: tutorialsReducer,
  configuration: ConfigurationReducer,
  avaliableOrganizations: AvaliableOrganizationsReducer,
  i18n: i18nReducer,
  formEditorTree: formEditorReducer,
  multiuser: multiuserReducer,
  portalTranslationConfig: PortalTranslationReducer,
  portalTranslationData: PortalTranslationDataReducer,
  testingOptions: TestingOptionsReducer,
  forms: FormsReducer,
  formRestrictions: FormRestrictionsReducer
})

export default RootReducer
